/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Input } from "reactstrap";
import SignaturePad from "react-signature-canvas";
import { base64StringtoFile } from "./EncodeImage";
import { Check } from "react-feather";
import Checkbox from "../../components/@vuexy/checkbox/CheckboxesVuexy";

import "./data.css";
class index extends Component {
  state = {
    trimmedDataURL: null,
    signature_name: "",
    remember: false,
    is_pass_signature_name: null,
    is_pass_signature: null,
    is_pass_tnc: null,
  };
  sigPad = {};
  clear = () => {
    this.sigPad.clear();
  };
  trim = () => {
    if (!this.sigPad.isEmpty()) {
      this.setState(
        {
          trimmedDataURL: this.sigPad.getTrimmedCanvas().toDataURL("image/png"),
          is_pass_signature: true,
        },
        () => {
          let fileName =
            this.state.signature_name !== ""
              ? this.state.signature_name + ".png"
              : "signature.png";
          let fileObj = {};
          fileObj = base64StringtoFile(this.state.trimmedDataURL, fileName);
          this.props.takeSnapShot(fileObj);
        }
      );
    } else {
      this.setState({
        is_pass_signature: false,
      });

    }
  };
  handleCheckBoxChange = () => {
    this.setState(
      (prevState) => ({
        remember: !prevState.remember,
      }),
      () => {
        if (this.state.remember === true) {
          this.setState({ is_pass_tnc: true });
        } else {
          this.setState({ is_pass_tnc: false });
        }
        this.props.acceptTNC(this.state.remember);
      }
    );
  };
  handleOnChange = (name, value) => {
    this.setState({ [name]: value, is_pass_signature_name: true }, () => {
      this.props.signatureName(this.state.signature_name);
    });
  };
  handleSubmitClick = () => {
    if (
      this.state.is_pass_signature === null ||
      this.state.is_pass_tnc === null ||
      this.state.is_pass_signature_name === null
    ) {
      this.setState(
        {
          is_pass_signature: this.state.is_pass_signature ? true : false,
          is_pass_tnc: this.state.is_pass_tnc ? true : false,
          is_pass_signature_name: this.state.is_pass_signature_name
            ? true
            : false,
        },
        () => {
          if (
            this.state.is_pass_signature &&
            this.state.is_pass_tnc &&
            this.state.is_pass_signature_name
          ) {
            this.props.handleSubmitWithSignature();
          }
        }
      );
    } else {
      if (
        this.state.is_pass_signature &&
        this.state.is_pass_tnc &&
        this.state.is_pass_signature_name
      ) {
        this.props.handleSubmitWithSignature();
      }
    }
  };
  render() {
    let { trimmedDataURL } = this.state;
    return (
      <>
        <div>
          {this.props?.isCart && this.props?.cart.finalOrderPrice ? (
            <p className="text-left">
              Total Amount with GST: {this.props?.cart.finalOrderPrice}
            </p>
          ) : (
            ""
          )}
        </div>
        <div className="signature-container mt-1">
          <div className="row">
            <div className="col-md-6 col-lg-4 mb-1">
              <div className="justify-content-start">
                <Input
                  type="text"
                  className="mw-100 form-control pr-0"
                  placeholder="Name"
                  name="signature_name"
                  value={this.state.signature_name}
                  onChange={(e) =>
                    this.handleOnChange(e.target.name, e.target.value)
                  }
                />
                {this.state.is_pass_signature_name !== null &&
                  !this.state.is_pass_signature_name && (
                    <div className="text-danger">Please enter name</div>
                  )}
              </div>
            </div>
            <div className="col-md-12 col-lg-9 mb-2">
              <div className="d-flex justify-content-start">
                <div className={"sigContainer w-100"}>
                  <SignaturePad
                    canvasProps={{ className: "sigPad" }}
                    ref={(ref) => {
                      this.sigPad = ref;
                    }}
                  />
                </div>
              </div>
              {this.state.is_pass_signature !== null &&
                !this.state.is_pass_signature && (
                  <div className="text-danger">Please add your signature</div>
                )}
            </div>
            <div className="col-md-12 col-lg-3 mb-2 mt-1 mt-md-0">
              <div className="sigbtn-container">
                <div className="d-inline-block d-lg-block mt-1 mt-md-0 align-top">
                  {" "}
                  <button
                    className={"btn btn-outline-primary px-2 py-1 w-100"}
                    onClick={this.clear}
                  >
                    CLEAR
                  </button>
                </div>
                <div className="d-inline-block d-lg-block ml-1 ml-lg-0 mt-1 mt-md-0 mt-lg-1 align-top">
                  <button
                    className={"btn btn-primary px-2 py-1 w-100"}
                    onClick={this.trim}
                  >
                    Confirm Sign
                  </button>
                </div>
                <div className="d-inline-block d-lg-block mt-1 mt-md-0 mt-lg-1 ml-1 ml-lg-0 align-top">
                  {trimmedDataURL ? (
                    <>
                      <p className="mb-0 mt-lg-1 mt-lg-0">Final Signature</p>
                      <img className={"sigImage"} src={trimmedDataURL} />
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-8">
              <div className="d-flex flex-wrap align-items-center justify-content-start">
                <Checkbox
                  color="primary"
                  icon={<Check className="vx-icon" size={16} />}
                  label="I agree to"
                  name="remember"
                  value={this.state.remember}
                  checked={this.state.remember}
                  onChange={this.handleCheckBoxChange}
                />
                <a
                  href={`${process.env.PUBLIC_URL}/terms-conditions`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="signup-privacy">Terms & Conditions *</span>
                </a>
              </div>
              {this.state.is_pass_tnc !== null && !this.state.is_pass_tnc && (
                <div className="text-danger">
                  Please select terms and conditions
                </div>
              )}
            </div>
          </div>
        </div>
        <div></div>
        <div className="col-md-12">
          <div className="inner-content text-right">
            <div className="btn-admin-group d-flex align-items-center justify-content-end">
              <Button
                color="primary"
                onClick={this.props.toggleSignatureModal}
                outline
              >
                CANCEL
              </Button>{" "}
              <Button
                className="ml-1"
                color="primary"
                onClick={this.handleSubmitClick}
              >
                SUBMIT
              </Button>{" "}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
  };
};
export default connect(mapStateToProps)(withRouter(index));
